/**
 * Firmanın tek "Üst Firma"sı (#373, sözleşme firm-list-tree.md v1.2): ya ana
 * firma ya da bayi. Sunucuda iki ayrı alan (`mainFirm`, `dealerFirm[]`) ve iki
 * ayrı uç vardır; panel ikisini tek alanda gösterir.
 *
 * Değer şekli: `{ kind: "main" | "dealer", id, firmName, firmType }` ya da null.
 */

const idOf = (v) => (v && typeof v === "object" ? v._id : v) || null;

/** Firmadan üst firma — ana firma öncelikli (v1.1 kilidiyle ikisi birlikte olmaz) */
export const parentOfFirm = (firm) => {
  if (!firm) return null;
  if (firm.mainFirm) {
    return {
      kind: "main",
      id: idOf(firm.mainFirm),
      firmName: firm.mainFirm.firmName || "",
      firmType: firm.mainFirm.firmType || firm.firmType || null,
    };
  }
  const dealers = Array.isArray(firm.dealerFirm) ? firm.dealerFirm : [];
  if (firm.firmType === "customer" && dealers.length > 0) {
    const d = dealers[0];
    return { kind: "dealer", id: idOf(d), firmName: d?.firmName || "Bayi", firmType: "dealer" };
  }
  return null;
};

/** Tek üst firmaya geçmeden önce birden fazla bayisi olan eski firmalar */
export const extraDealersOf = (firm) =>
  firm?.firmType === "customer" && Array.isArray(firm.dealerFirm) ? firm.dealerFirm.slice(1) : [];

export const sameParent = (a, b) =>
  (a?.kind || null) === (b?.kind || null) && String(a?.id || "") === String(b?.id || "");

/**
 * Kaydetme adımları — sunucu kilidi (v1.1) yüzünden önce eski bağlantı
 * kaldırılır:
 *  - `clearDealersFirst`: bayiden ana firmaya / boşa geçerken önce bayiler
 *  - `mainFirmName`: updateFirmInfo'ya gidecek değer (ana firma yoksa "none")
 *  - `dealerFirmIds`: en son yazılacak bayi listesi (değişmiyorsa null)
 */
export const parentSavePlan = (firm, next) => {
  const prev = parentOfFirm(firm);
  const hasDealers = firm?.firmType === "customer" && (firm?.dealerFirm || []).length > 0;
  const changed = !sameParent(prev, next) || (next?.kind === "dealer" && extraDealersOf(firm).length > 0);
  return {
    changed,
    clearDealersFirst: changed && hasDealers && next?.kind !== "dealer",
    mainFirmName: next?.kind === "main" ? next.firmName : "none",
    dealerFirmIds: changed && next?.kind === "dealer" ? [String(next.id)] : null,
  };
};

/** Firma tipine göre üst firma etiketi */
export const parentKindLabel = (parent, firmType) => {
  if (!parent) return null;
  if (parent.kind === "dealer") return "Bayi";
  return firmType === "dealer" ? "Ana Bayi" : "Ana Firma";
};
